import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import StickyDiscussionModal from './components/StickyDiscussionModal';

export default function addStickyControl() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    let tagItem = sessionStorage.getItem('tagItem');
    const tag = app.store.getBy('tags', 'slug', tagItem);
    let isAllTag = tag && tag.isAllTag();
  
    if (discussion.canSticky()) {
      items.add(
        'sticky',
        <Button icon="fas fa-thumbtack" onclick={this.stickyAction.bind(discussion)}>
          {app.translator.trans(`flarum-sticky.forum.discussion_controls.${(isAllTag ? discussion.isAllSticky() : discussion.isSticky()) ? 'unsticky' : 'sticky'}_button`)}
        </Button>
      );
    }
  });

  DiscussionControls.stickyAction = function () {
    let tagItem = sessionStorage.getItem('tagItem');
    const tag = app.store.getBy('tags', 'slug', tagItem);
    let isAllTag = tag && tag.isAllTag();
    
    return app.modal.show(StickyDiscussionModal, {
      currentTitle: this.title(),
      discussion: this,
      isAllTag: isAllTag
    });
    // if (this.isSticky()) {
    //   this.save({ isSticky: !this.isSticky() }).then(() => {
    //     if (app.current.matches(DiscussionPage)) {
    //       app.current.get('stream').update();
    //     }
  
    //     m.redraw();
    //   });
    // }else {
    //   return app.modal.show(StickyDiscussionModal, {
    //     currentTitle: this.title(),
    //     discussion: this,
    //   });
    // }
    
  }
}

//   DiscussionControls.stickyAction = function () {
//     this.save({ isSticky: !this.isSticky() }).then(() => {
//       if (app.current.matches(DiscussionPage)) {
//         app.current.get('stream').update();
//       }

//       m.redraw();
//     });
//   };
// }
